"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDiscountCommand = void 0;
const ddd_library_1 = require("@hoepel.app/ddd-library");
const discount_1 = require("../discount");
class AddDiscountCommand extends ddd_library_1.CommandBase {
    constructor() {
        super(...arguments);
        this.name = 'add-discount-command';
    }
    static create(discount, metadata) {
        return new AddDiscountCommand({ discountProps: discount.toProps() }, metadata);
    }
    get discount() {
        return discount_1.Discount.fromProps(this.payload.discountProps);
    }
}
exports.AddDiscountCommand = AddDiscountCommand;
//# sourceMappingURL=add-discount.command.js.map